"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TxRelatedId = void 0;
var Sha256_1 = require("./Sha256");
var TxRelatedId = /** @class */ (function () {
    function TxRelatedId() {
    }
    TxRelatedId.create = function (chainId, transactionHash) {
        var safeTransactionHash = transactionHash.toLowerCase();
        return Sha256_1.Sha256.hash("".concat(chainId, ";").concat(safeTransactionHash));
    };
    return TxRelatedId;
}());
exports.TxRelatedId = TxRelatedId;
//# sourceMappingURL=TxRelatedId.js.map